import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { _Cities, _CountriesVdos, _StatesCatalog } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../../../theme/Component/usePaginator";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { CountriesEditor } from "../CountriesEditor";
import { StatesCatalogEditor } from "../StatesCatalog/StatesCatalogEditor";

interface Props {
    idCountries: number;
}

export const Cities = ({ idCountries }: Props) => {

    const cities = useDataBean(_Cities);
    const paginador = usePaginator();
    const [regexStr, setregexStr] = useState<any>(null)
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [form, setForm] = useState<any>({
        idState: null,
        StateName: null
    })
    const [modalcities, setModalcities] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalstates, setModalstates] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [idCountries, paginador.page])

    const getLista = () => {

        cities.instance.getCitiesCatalog(idCountries, form.idState, regexStr, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (15));
                    paginador.setRegiPerPage(15)
                    setLista(resp.List)
                }
            }
        )

    }
    const create = () => {
        cities.setBean({
            IDCountries: idCountries
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        cities.instance.deleteCities(cities.bean.IDCities).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        cities.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDCities', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Código Ciudad', property: 'CityCode', visible: true },
        { title: 'Código IATA', property: 'IATACode', visible: true },
        { title: 'Latitud', property: 'Latitude', visible: true },
        { title: 'Longitud', property: 'Longitude', visible: true },

    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    return (
        <BasicPage titulo="Ciudades">
            <div className="row">
                <div className="col-md-6">
                    <label>Búsqueda por Texto</label>
                    <input type="text" className="form-control" value={regexStr} onChange={(e) => { setregexStr(e.target.value) }} />
                </div>
                <div className="col-md-6">
                    <StatesCatalogEditor idCountries={idCountries} render={form.StateName} idSelector={form.idState} onChange={(e) => { setForm({ ...form, "idState": e.IDState, "StateName": e.Name }) }} returnType="Object" />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={cities.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                <StatesCatalogEditor idCountries={idCountries} render={cities.bean.StateName} idSelector={cities.bean.IDState} onChange={(e) => { cities.setBean({ ...cities.bean, "IDState": e.IDState, "StateName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={cities.bean.Name} onChange={(e) => { cities.setBean({ ...cities.bean, "Name": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Código Ciudad</label>
                                <input type="text" name="CityCode" className="form-control" value={cities.bean.CityCode} onChange={(e) => { cities.setBean({ ...cities.bean, "CityCode": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Código IATA</label>
                                <input type="text" name="IATACode" className="form-control" value={cities.bean.IATACode} onChange={(e) => { cities.setBean({ ...cities.bean, "IATACode": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Latitud</label>
                                <input type="text" name="Latitude" className="form-control" value={cities.bean.Latitude} onChange={(e) => { cities.setBean({ ...cities.bean, "Latitude": e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Longitud</label>
                                <input type="text" name="Longitude" className="form-control" value={cities.bean.Longitude} onChange={(e) => { cities.setBean({ ...cities.bean, "Longitude": e.target.value }) }} />
                            </div>

                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {cities.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}